<acabim-card cardHeading="Confirm Delete Records" [cardContent]="deleteModal"></acabim-card>


<ng-template #deleteModal>
    <div *ngIf="deleteData.length > 0">
        <div class="cas-flex-row" *ngFor="let control of deletePayload; let i = index">
            <div class="p-col-4">
                <span>{{control.label}}</span>
            </div>
            <div class="p-col-8">
                <span>{{control.value}}</span>
            </div>
        </div>
        <div class="cas-action-buttons">
            <button class="cas-button-action" (click)="cancel('delete')">OK</button>
        </div>
    </div>
    <div *ngIf="deleteData.length === 0">
        <p>No Records Selected</p>
        <div>
            <button (click)="cancel('cancel')">CANCEL</button>
        </div>
    </div>
</ng-template>
